// extracted by mini-css-extract-plugin
export default {"form":"UsuarioForm_form__d8K8k"};